import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'
import { TranslateModule } from '@ngx-translate/core'

import { MaintenanceBannerComponent } from './maintenance-banner.component'

@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    TranslateModule,
  ],
  declarations: [MaintenanceBannerComponent],
  exports: [MaintenanceBannerComponent],
})
export class MaintenanceBannerModule {}
